import { render } from "./index-achievement-list.vue?vue&type=template&id=0021da4e&scoped=true"
import script from "./index-achievement-list.vue?vue&type=script&lang=js"
export * from "./index-achievement-list.vue?vue&type=script&lang=js"

import "./index-achievement-list.vue?vue&type=style&index=0&id=0021da4e&scoped=scoped&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0021da4e"]])

export default __exports__